__turbopack_context__.v({
  "discountBanner": "TopUpCredits-module__ZoHrXW__discountBanner",
  "discountIcon": "TopUpCredits-module__ZoHrXW__discountIcon",
  "infoCard": "TopUpCredits-module__ZoHrXW__infoCard",
  "modalBody": "TopUpCredits-module__ZoHrXW__modalBody",
  "modalHeader": "TopUpCredits-module__ZoHrXW__modalHeader",
  "priceCard": "TopUpCredits-module__ZoHrXW__priceCard",
  "savingsIcon": "TopUpCredits-module__ZoHrXW__savingsIcon",
  "submitButton": "TopUpCredits-module__ZoHrXW__submitButton",
  "subscribeBanner": "TopUpCredits-module__ZoHrXW__subscribeBanner",
  "totalDivider": "TopUpCredits-module__ZoHrXW__totalDivider",
  "totalPrice": "TopUpCredits-module__ZoHrXW__totalPrice",
  "upgradeHint": "TopUpCredits-module__ZoHrXW__upgradeHint",
  "upgradeHintInline": "TopUpCredits-module__ZoHrXW__upgradeHintInline",
});
